const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，经纪人火速否认', heat: '238.6w', trend: 'fire' },
  { rank: 2, title: '某王牌综艺录制现场失控，导演怒摔台本离场', heat: '196.3w', trend: 'fire' },
  { rank: 3, title: '古装大剧女主换角风波延烧，五大候选人曝光', heat: '178.9w', trend: 'hot' },
  { rank: 4, title: '知名男星被拍与女助理同游日本举止亲密', heat: '154.7w', trend: 'hot' },
  { rank: 5, title: '人气歌手新专辑陷抄袭争议，乐评圈集体开撕', heat: '132.5w', trend: 'hot' },
  { rank: 6, title: '某剧组杀青宴上两位主演因番位发生激烈冲突', heat: '118.2w', trend: 'up' },
  { rank: 7, title: '某品牌与代言人突然解约，双方各执一词', heat: '96.8w', trend: 'up' },
];

export default function RankingSection() {
  const rankColors: Record<number, string> = {
    1: 'bg-primary-500',
    2: 'bg-primary-400',
    3: 'bg-accent-500',
  };

  const trendIcons: Record<string, string> = {
    fire: 'ri-fire-line text-primary-500',
    hot: 'ri-fire-line text-accent-500',
    up: 'ri-arrow-up-line text-secondary-600',
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            吃瓜热度榜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">实时更新，全网最热吃瓜排名</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-2">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 rounded-xl p-4 cursor-pointer transition-all duration-300 hover:-translate-x-1"
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center text-sm font-bold text-background-50 flex-shrink-0 ${
                rankColors[item.rank] || 'bg-secondary-400'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-800 truncate">{item.title}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <i className={trendIcons[item.trend]}></i>
                <span className="text-sm font-medium text-foreground-500 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}